if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");

      /* ---- ADDED: mobile / tablet settings ---- */
      this.itemsTablet = this.dataset.itemsTablet || Math.max(parseInt(this.items) - 1, 1);
      this.itemsMobile = this.dataset.itemsMobile || 1;
      this.rowsMobile = parseInt(this.dataset.rowsMobile || 1);
      this.mobileLayout = this.dataset.mobileLayout || "slider";
      this.loopMobile = this.dataset.mobileLoop !== "false";
      this.showPaginationMobile = this.dataset.showPaginationMobile === "true";
      this.showNavigationMobile = this.dataset.showNavigationMobile === "true";
      this.mobileQuery = window.matchMedia("(max-width: 767px)");
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.lastActive = null;
      if (!this.enableSlider) return;

      this.setupLayout();

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener("change", this.onBreakpointChange);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.onBreakpointChange);
      }

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    disconnectedCallback() {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener("change", this.onBreakpointChange);
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onBreakpointChange);
      }
      this.destroySlider();
    }

    onBreakpointChange() {
      this.setupLayout();
    }

    /* ADDED: decides whether the Swiper should run at the current breakpoint */
    setupLayout() {
      const isMobile = this.mobileQuery.matches;
      const staticOnMobile = isMobile && this.mobileLayout !== "slider";

      if (staticOnMobile) {
        this.classList.add("m-icon-box--mobile-static");
        this.destroySlider();
      } else {
        this.classList.remove("m-icon-box--mobile-static");
        if (!this.slider) this.initSlider();
      }
    }

    destroySlider() {
      if (this.slider) {
        try {
          this.slider.destroy(true, true);
        } catch (e) {
          /* no-op */
        }
        this.slider = null;
      }
    }

    /* ADDED: per-breakpoint Swiper params */
    getBreakpoints() {
      const mobile = {
        slidesPerView: parseFloat(this.itemsMobile) || 1,
      };

      if (this.rowsMobile > 1) {
        mobile.grid = { rows: this.rowsMobile, fill: "row" };
      } else {
        mobile.grid = { rows: 1 };
      }

      return {
        0: mobile,
        480: {
          slidesPerView: parseFloat(this.itemsMobile) || 1,
          grid: this.rowsMobile > 1 ? { rows: this.rowsMobile, fill: "row" } : { rows: 1 },
        },
        768: {
          slidesPerView: parseInt(this.itemsTablet) || Math.max(parseInt(this.items) - 1, 1),
          grid: { rows: 1 },
        },
        1280: {
          slidesPerView: parseInt(this.items),
          grid: { rows: 1 },
        },
      };
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const wrapper = this.querySelector(".swiper-wrapper");
      const slideItemsLength = wrapper ? wrapper.childElementCount : 0;
      const isMobile = this.mobileQuery.matches;
      const useLoop = isMobile ? this.loopMobile && this.rowsMobile === 1 : true;
      const usePagination = this.showPagination || this.showPaginationMobile;
      const useNavigation = this.showNavigation || this.showNavigationMobile;
      let __this = this;

      if (!this.slideContainer) return;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        navigation: useNavigation,
        loop: useLoop,
        pagination: usePagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: this.getBreakpoints(),
        on: {
          init: function () {
            if (__this.lastActive !== null && __this.lastActive !== undefined) {
              this.slideToLoop(__this.lastActive);
            }
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton?.classList.remove("m:hidden");
                nextButton?.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              const rows = (breakpointParams.grid && breakpointParams.grid.rows) || 1;
              const visible = slidesPerView * rows;
              if (slideItemsLength > visible) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && useNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider && this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider && this.slider.slideNext());
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      if (Number.isNaN(index)) return;
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
